import {Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {FormControl} from "@angular/forms";
import {Observable} from "rxjs/Observable";
import {Subscription} from "rxjs/Subscription";
import {debounceTime, distinctUntilChanged, finalize} from "rxjs/operators";
import {KeyboardOptions} from "virtual-keyboard";
import {GERMAN_LAYOUT} from "../../directives/on-screen-keyboard.directive";

@Component({
  selector: 'vb-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.css']
})
export class SearchInputComponent implements OnInit, OnDestroy {

  kbOptions: KeyboardOptions = {
    type: 'input',
    layout: 'custom',
    customLayout: GERMAN_LAYOUT
  };

  @Input()
  touchMode: boolean = false;

  //@HostBinding('class')
  //private classAttr = "has-deselect-icon";

  @HostBinding('style')
  private width = "100%";

  @Input()
  formGroupStyle: string;

  @Input()
  placeholder: string = "Suche...";

  @Input()
  searchTermControl: FormControl = new FormControl(null);

  @Input()
  observableSearchFunction: (term: string) => Observable<any>;

  @Input()
  searchFunction: (term: string) => any[];

  @Output()
  searchStarted: EventEmitter<any> = new EventEmitter();

  @Output()
  searchFinished: EventEmitter<any> = new EventEmitter();

  @Output()
  searchCleared: EventEmitter<any> = new EventEmitter();

  @Output()
  loadingStateChanged: EventEmitter<boolean> = new EventEmitter();

  private _loading: boolean = false;

  get loading(): boolean {
    return this._loading;
  }

  set loading(value: boolean) {
    this._loading = value;
    this.loadingStateChanged.emit(value);
  }

  private searchSub: Subscription;
  private ctrlSub: Subscription;

  constructor() {
  }

  ngOnInit() {

    this.ctrlSub = this.searchTermControl.valueChanges.subscribe(val => {
      if (!val) {
        this.onClearClicked();
      }
    });

    if (this.searchFunction && this.observableSearchFunction) {
      console.warn("Both, a search function and an observable search function have been provided: both will be execuded during search which may result in unexpected behaviour!");
    }

    this.searchSub = this.searchTermControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
      .subscribe(term => {
          if (!term || !term.length) {
            this.searchCleared.emit();
            return;
          }

          this.loading = true;
          this.searchStarted.emit();

          if (this.searchFunction) {
            this.loading = false;
            this.searchFinished.emit(this.searchFunction(term));
          }

          if (this.observableSearchFunction) {
            this.observableSearchFunction(term)
              .pipe(
                finalize(() => {
                  this.loading = false;
                })
              )
              .subscribe(result => {
                this.loading = result.loading ? result.loading : false;
                this.searchFinished.emit(result);
              });
          }

        }, err => {
          this.loading = false;
        }
      );

  }

  runSearch(term) {
    this.searchTermControl.setValue(term);
  }

  ngOnDestroy(): void {
    this.loading = false;
    if (this.searchSub
    ) {
      this.searchSub.unsubscribe();
    }
    if (this.ctrlSub) {
      this.ctrlSub.unsubscribe();
    }
  }

  resetFilter() {
    this.loading = false;
    this.searchTermControl.reset();
  }

  onClearClicked() {
    this.loading = false;
    this.searchCleared.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/navigation/search-input/search-input.component.ts